<template>
  <div class="_contract">
    <form v-on:submit.prevent="ButtonNext()">
      <div class="row m-0 navigation">
        <b-button-group class="row mx-0 px-4 navigation">
          <b-button @click="ButtonPrev">
            <img  src = "@/assets/image/icon/icon-rectangle.svg">
            Back
          </b-button>
          <b-button type="submit">
            Submit
            <img  src = "@/assets/image/icon/icon-rectangle.svg">
          </b-button>
        </b-button-group>
      </div>

      <div class="pricingadditional_">
        <h3 class="text-center __titleGlobal">Pricing &#38; Additional options</h3>
        <div class="row justify-content-end __centerblock">
          <div class="col-md-6 p-0 __block1">
              <h3 class="__title2">Ideal Budget</h3>
              <div class="row m-0 __idr">
                <b-input-group class="__inputgroup"  prepend="IDR">
                  <money class="__price2" :class="data.request_rate === 0 ? 'init_value' : ''" v-model="data.request_rate" :value="data.request_rate" ></money>
                  <div v-if="showErrorPricing && error.request_rate" class="text-left input-group __input">
                    <small class="text-danger">Required</small>
                  </div>
                </b-input-group>
                <hr>
                <b-input-group class="__price1">
                  <money class="__money __price2" :class="data.request_rate_to === 0 ? 'init_value' : ''" v-model="data.request_rate_to" :value="data.request_rate_to" ></money>
                  <div v-if="showErrorPricing && error.request_rate_to" class="text-left input-group __input">
                    <small class="text-danger">Required</small>
                  </div>
                </b-input-group>
              </div>
              <p v-if="error.budget" class="fontstyle__errormsg">
                  {{ error.budget }}
              </p>

              <div class="insurance">
                <h3 class="__title2 mt-3">Insurance</h3>
                <div class="options__multipleselect">
                  <multiselect
                    name="insurance"
                    :state="errors.first('insurance') && false"
                    v-validate="'required'"
                    v-model="selectedInsurance"
                    :options="insuranceOption" :allow-empty="false"
                    label="name" @input="onSelectInsurance"
                    placeholder="Select your insurance"
                    :select-label="''" :deselect-label="''">
                    <span slot="noResult">Oops! No elements found.</span>
                  </multiselect>
                </div>
                <p v-if="showErrorPricing && error.insurance" class="fontstyle__errormsg">
                    The insurance field is required
                </p>
              </div>
              
              <h3 class="__title2 mt-3">Remarks : *optional</h3>
              <div class="__customdropdown_dst">
                <div>
                  <b-form-textarea
                    id="textarea"
                    v-model="data.note_for_merchant"
                    placeholder="Type here"
                    rows="3"
                    max-rows="5"
                    class="__textarea"
                  />
                  <pre class="mt-3 mb-0"></pre>
                </div>
              </div>
          </div>
          <div class="col-md-1 p-0">
            <div class="text-center __block2">
            </div>
          </div>
          <div class="col-md-5 p-0 __block3">
            <h3 class="__title2">Additional Options</h3>
            <div class="__addoption">
              <img class="__icon" src = "@/assets/image/icon/customs.svg">
              <span class="__text">Customs Clearance (Origin)</span>
              <div class="custom-control custom-switch __switchCustom">
                <input
                  type="checkbox"
                  v-model="data.option_customs_clearance"
                  class="custom-control-input"
                  id="customSwitch2">
                <label class="custom-control-label" for="customSwitch2"></label>
              </div>
            </div>
            <div class="__addoption">
              <img class="__icon" src = "@/assets/image/icon/customs.svg">
              <span class="__text">Customs Clearance (Destination)</span>
              <div class="custom-control custom-switch __switchCustom">
                <input
                  type="checkbox"
                  v-model="data.option_customs_clearance_destination"
                  class="custom-control-input"
                  id="customSwitch3">
                <label class="custom-control-label" for="customSwitch3"></label>
              </div>
            </div>
            <div class="__addoption">
              <img class="__icon" src = "@/assets/image/icon/storage.svg">
              <span class="__text">Estimate Storage</span>
              <div class="custom-control custom-switch __switchCustom">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="data.option_estimate_storage"
                  id="customSwitch4">
                <label class="custom-control-label" for="customSwitch4"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <b-modal ref="processcontract" id="processcontract" :cancel-disabled="true" :no-close-on-backdrop="true" hide-footer :hide-header-close="true">
      <div class="d-block text-center">
        <div>
          <b-spinner label="Loading..."></b-spinner>
        </div>
        <h5>Loading</h5>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PricingAndAdditional',
  props: {
    showErrorPricing: Boolean
  },
  data () {
    return {
      textArea: '',
      terms: 'Term of Payment',
      selectedInsurance: null,
      data: {
        insuranceId: null,
        option_insurance: true,
        option_customs_clearance: false,
        option_customs_clearance_destination: false,
        option_estimate_storage: false,
        request_rate: '',
        request_rate_to: '',
        paymentReferences: '',
        note_for_merchant: ''
      },
      error: {
        budget: 0
      }
    }
  },
  computed: {
    // fetch account
    ...mapGetters({
      account: 'settingAccount/account',
      errorAccount: 'settingAccount/error',
      isLoading: 'settingAccount/isLoading',

      insuranceOption: 'insurance/insuranceList',
      isLoadingInsuranceList: 'insurance/isLoadingInsuranceList'
    })
  },
  watch: {
  },
  mounted () {
    this.init()
  },
  methods: {
    onSelectInsurance () {
      this.data.insuranceId = this.selectedInsurance.id
    },
    chkTerms (data) {
      this.terms = data === 'Cash' ? data : data + ' Days'
      this.data.paymentReferences = data
    },
    init () {
      this.data.paymentReferences = this.account && this.account.termofpayment ? this.account.termofpayment : 14
      this.$store.dispatch('insurance/INSURANCE_LIST')
    },

    ButtonNext () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.data.request_rate > 0 && this.data.request_rate_to > 0) {
            if (this.data.request_rate > this.data.request_rate_to) {
              this.error.budget = 'Budget range is invalid, please type your minimal and then your maximum budget (must be larger than the first one)'
            } else {
              this.$refs['processcontract'].show()
              this.error.budget = ''
              this.$emit('inputData', this.data)
              this.$emit('tabIndex')
              setTimeout(() => {
                this.$refs['processcontract'].hide()
              }, 1000)
            }
          } else {
            this.error.budget = 'The ideal budget field is required'
          }
        }
      })
      this.$refs['processcontract'].hide()
    },
    ButtonPrev () {
      this.$emit('tabIndexPrev')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contract/PricingAdditional.vue